/**
 * Created by lhzbxx on 2016/10/20.
 *
 * auth.js
 * 身份认证相关
 */

import commissionApi from "../../api/commission"
import balanceApi from "../../api/balance"

const state = {
  commissionList: [],
  balance: {
    id: -1,
    amount: -1.00,
    frozenAmount: -1.00,
  },
  pageCount: 0
}

const mutations = {
  saveBalance (state, balance) {
    state.balance = balance
  },
  addCommissionList (state, list) {
    // debugger
    state.commissionList = state.commissionList.concat(list)
  },
  saveCommissionList (state, page) {
    state.commissionList = page.content
    state.pageCount = page.totalPages
  }
}
const actions = {
  async fetchCommissionList(context, page)  {
    let {commit, state, rootState} = context
    let pb = await commissionApi.list(page)
    commit('saveCommissionList', pb)
  },
  async fetchBalance(context)  {
    let {commit, state, rootState} = context
    let data = await balanceApi.info()
    commit('saveBalance', data)
  }
}

export default {
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/module/commission.js